import OnboardingPage from "../../common/components/OnboardingPage";
import { REWARD_OFFERING } from "../../constants";
import { getRedeemUrlWithContext } from "../../utils";

function MyCarTacticalMain() {
  const redeemUrl = getRedeemUrlWithContext("mycar-tactical");

  return (
    <>
        <OnboardingPage
          redeemUrl={redeemUrl}
          rewardId={REWARD_OFFERING.mycartactical}
        />
    </>
  );
}

export default MyCarTacticalMain;
